export default __webpack_public_path__ + "img/arrow-down.647687ea.svg";